import { getConta } from '../../../utils/getConta'
import apinode from '../../apinode'

class PedidosService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getDailySales(date) {
    const conta = getConta()

    const response = await apinode.get(
      `/pedido/get_daily_sales/${conta}?date=${date}`,
    )

    return response.data
  }

  async unifyOrders(ordersIds) {
    const response = await apinode.post(`/pedido/unify/${this.idconta}`, {
      ordersIds,
    })

    return response.data.message
  }

  async orderCheckout(orderId, usercheckconf) {
    await apinode.patch(`/pedido/checkout/${orderId}/${this.idconta}`, {
      usercheckconf,
    })
  }

  async checkItem(itemId) {
    await apinode.patch(`/pedido/checkout/item/${itemId}/${this.idconta}`)
  }

  async exportOrderToBelaHomeDatabase(orderId) {
    const response = await apinode.get(
      `/pedido/export-order-bh/${orderId}/${this.idconta}`,
    )

    return response.data
  }
}

export default new PedidosService()
